import React, { useEffect, useContext } from "react";
import { addCommas } from "@persian-tools/persian-tools";
import { CirclePicker } from "react-color";
import Rate from "rc-rate";
import "rc-rate/assets/index.css";
import { useState } from "react";
import ReactDOM from "react-dom";
import EditProductModal from "./EditProductModal";
import sendRequest from "hooks/useAxios";
import { BiMinus } from "react-icons/bi";
import { BsPlus } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

import "../SingleProduct/SingleProduct.scss";

import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import "filepond/dist/filepond.min.css";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
function DetailProduct({
  product,
  isAdmin,
  setUpdateProduct,
  tags,
  setTags,
  colors,
  setUpdater,
  productId,
}) {
  const [attachedfile, setAttachedFile] = useState([]);

  // colors of product
  const navigate = useNavigate();
  const colorArray = [];
  product.colors.map((value, index) => {
    colorArray.push(value.hex);
  });
  const [count, setCount] = useState(1);
  const [selectColor, setSelectColor] = useState("");
  useEffect(() => {
    setSelectColor(product.colors.length > 0 ? product.colors[0].hex : "");
  }, [product]);
  // console.log("selectColor", selectColor);
  // console.log("selectColor", product);
  // const [maxBuy, setMaxBuy] = useState(product.colors[0].inventory);
  // const [selectColor, setSelectColor] = useState(product.colors[0].hex);
  const [maxBuy, setMaxBuy] = useState(0);

  const auth = useContext(WithAuthentication);
  useEffect(() => {
    let x = 0;
    if (product.colors.length > 0) {
      x = product.colors[0]?.inventory;
    } else {
      x = isNaN(product.inventory_count) ? 0 : Number(product.inventory_count);
    }
    setMaxBuy(x);
  }, [product.inventory_count]);
  useEffect(() => {
    setCount(1);
  }, [productId]);
  const countFunction = (operation) => {
    if (operation == "plus" && count < maxBuy) {
      setCount((prev) => +prev + 1);
    } else if (operation == "minus" && count > 1) {
      setCount((prev) => +prev - 1);
    }
  };

  function addToBasket() {
    // console.log("hello", auth.isLogged);
    if (auth.isLogged) {
      let theColor = product.colors.find((value) => value.hex === selectColor);
      let fd = new FormData();
      fd.append("productId", product.id);
      // if (theColor != "") {
      product.colors?.length > 0 && fd.append("colorid", theColor.id);
      // }
      // theColor !="" &&
      fd.append("itemcount", count);

      fd.append("situation", "Creation");
      // fd.append("situation", "increase");
      for (let i = 0; i < attachedfile.length; i++) {
        fd.append("files", attachedfile[i]);
      }
      sendRequest("cartitem", fd).then(({ data }) => {
        if (data.status == 1) {
          Swal.fire({
            title: "محصول با موفقیت به سبد خرید اضافه شد.",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            title: "خطا!",
            text: "مشکلی پیش آمده، لطفا بعدا امتحان کنید.",
            icon: "error",
            confirmButtonText: "متوجه شدم",
          });
        }
      });
    } else {
      toast.error("ابتدا وارد حساب کاربری تان شوید.");
      // Swal.fire({
      //   title: "خطا!",
      //   text: "ابتدا وارد حساب کاربری تان شوید.",
      //   icon: "error",
      //   confirmButtonText: "متوجه شدم"
      // });
    }
  }

  const adminButtons = (
    <div className="d-flex justify-content-end pe-3">
      <button
        className="btn bg-success text-light"
        data-bs-toggle="modal"
        data-bs-target="#editProductModal"
      >
        ویرایش
      </button>
      <button
        className="btn bg-danger text-light mx-1"
        onClick={() => {
          Swal.fire({
            icon: "warning",
            title: "آیا از حذف این محصول مطمئن هستید؟",
            showCancelButton: true,
            cancelButtonText: "انصراف",
            confirmButtonText: "حذف",
            cancelButtonColor: "#EF394E",
            confirmButtonColor: "#439B58",
          }).then(({ isConfirmed }) => {
            if (isConfirmed) {
              sendRequest("deleteproduct", { productId: product.id }).then(
                ({ data }) => {
                  if (data.status == 1) {
                    Swal.fire({
                      title: "محصول با موفقیت حذف شد.",
                      showConfirmButton: false,
                      timer: 2000,
                    });
                    navigate("/store", { replace: true });
                  }
                }
              );
            }
          });
        }}
      >
        حذف
      </button>
      <button
        className="btn btn-warning text-white"
        onClick={() => {
          Swal.fire({
            icon: "warning",
            title: "آیا از غیر فعال کردن این محصول مطمئن هستید؟",
            showCancelButton: true,
            cancelButtonText: "انصراف",
            confirmButtonText: "غیر فعال",
            cancelButtonColor: "#EF394E",
            confirmButtonColor: "#ffc107",
          }).then(({ isConfirmed }) => {
            if (isConfirmed) {
              // sendRequest("deleteproduct", { productId: product.id }).then(
              //   ({ data }) => {
              //     if (data.status == 1) {
              //       Swal.fire({
              //         title: "محصول با موفقیت غیرفعال شد.",
              //         showConfirmButton: false,
              //         timer: 2000
              //       });
              //       navigate("/store", { replace: true });
              //     } else {
              //       Swal.fire({
              //         title: "مشکلی در غیرفعال کردن محصول پیش آمده!",
              //         showConfirmButton: false,
              //         timer: 2000
              //       });
              //     }
              //   }
              // );
            }
          });
        }}
      >
        غیرفعال
      </button>
    </div>
  );

  // price and counter section

  const priceSection = (
    <>
      {" "}
      <div className=" mx-auto my-2">
        {product.main_discount != "0" ? (
          <>
            <del className="text-danger">
              {addCommas(product.main_price)} تومان
            </del>
            <div className="">
              {addCommas(product.main_price - product.main_discount)} تومان
            </div>
          </>
        ) : (
          <p className="mx-1">{addCommas(product.main_price)} تومان </p>
        )}
      </div>
      {!isAdmin && (
        <>
          {/* counter */}
          <div className="align-self-end my-2 mx-auto">
            <div
              className="d-flex mx-auto  mb-1 rounded"
              style={{
                backgroundColor: "rgb(237 238 240)",
                height: "30px",
                width: "80px",
              }}
            >
              <button
                className="btn shadow-none bg-navy h-100 d-flex justify-content-center align-items-center"
                style={{ width: "20px" }}
              >
                <BsPlus
                  className="cursor-pointer text-light fs-5 position-absolute"
                  // style={{ right: "2px" }}

                  onClick={() => {
                    countFunction("plus");
                  }}
                />
              </button>
              <div className="mx-2 align-self-center">{count}</div>
              <button
                className="btn shadow-none  bg-navy h-100 d-flex justify-content-center align-items-center"
                style={{ width: "20px" }}
              >
                <BiMinus
                  className="cursor-pointer text-light fs-5 position-absolute"
                  onClick={() => {
                    countFunction("minus");
                  }}
                />
              </button>
            </div>
            <div className=" validation-txt " style={{ height: 20 }}>
              {maxBuy == count ? (
                <div className="mx-auto">حداکثر تعداد خرید : {maxBuy}عدد</div>
              ) : null}
              {maxBuy == "0" ? (
                <div className="mx-auto">
                  موجودی این کالا به پایان رسیده است.
                </div>
              ) : null}
            </div>
          </div>
          {/* buy basket */}
          <div className="ms-auto px-3 add-to-basket">
            <button
              className=" px-4 py-2 btn bg-danger text-light round "
              onClick={addToBasket}
              disabled={maxBuy == "0" ? true : false}
            >
              افزودن به سبد خرید
            </button>
          </div>
        </>
      )}
    </>
  );

  const colorSection = (
    <div>
      {
        <div className="d-flex align-items-center ">
          <div className="me-3 my-3">رنگبندی:</div>

          <CirclePicker
            className="w-100"
            colors={colorArray}
            color={selectColor ? selectColor : colorArray[0]}
            circleSize={15}
            // value={selectColor}
            // onSwatchHover={("red", "onClick")}
            onChange={(e) => {
              setCount(1);
              const selectInventory = product.colors.filter(
                (color) => color.hex == e.hex
              );
              if (selectInventory.length != 0) {
                setSelectColor(selectInventory[0].hex);
                setMaxBuy(selectInventory[0].inventory);
              } else {
                setSelectColor(null);
                setMaxBuy(Number(product.inventory_count));
              }
            }}
          ></CirclePicker>
        </div>
      }

      {/* {product.colors.map((value) => {
        return (
          <div>{`موجودی رنگ ${value.title}: ${value.inventory}  عدد می باشد.`}</div>
        );
      })} */}
    </div>
  );

  return (
    <div className="ms-5 mt-5">
      <> {isAdmin && adminButtons}</>
      <div className="d-flex flex wrap justify-content-between">
        <h5 className="my-3 ">{product.title}</h5>
      </div>

      <p className="my-2">{product.description}</p>

      {product.colors && product.colors.length > 0 && colorSection}
      <div className="d-flex align-items-baseline my-3">
        <div>{product.avg_rating} از 5</div>
        <div className="ms-3">
          <Rate
            direction="rtl"
            style={{ fontSize: 25 }}
            // allowHalf={true}
            disabled={true}
            value={product.avg_rating}
          />
        </div>
      </div>

      <div className="d-flex flex-wrap   align-items-baseline">
        {product.main_price && priceSection}
      </div>

      <div>
        {product.enable_upload_file == "1" && !isAdmin && (
          <div className="my-4 ">
            <label className="mb-2">آپلود فایل مورد نظر :</label>
            <div className="">
              <input
                className="form-control"
                type="file"
                onChange={(e) => {
                  setAttachedFile(e.target.files);
                }}
              ></input>
            </div>
          </div>
        )}
      </div>
      {/* edit modal */}
      {ReactDOM.createPortal(
        <EditProductModal
          product={product}
          setUpdateProduct={setUpdateProduct}
          tags={tags}
          setTags={setTags}
          colors={colors}
        />,
        document.getElementById("editProduct")
      )}
    </div>
  );
}

export default DetailProduct;
